export default __webpack_public_path__ + "static/Am@2x-1f454e6aedd22b21372e6a3aba8d8c3c.png";